// Bump BUILD_STAMP whenever a native app rebuild ships, so stale
// bundles on devices are instantly identifiable from Settings.
export const BUILD_STAMP = "web bundle 2026-08-22";
export const APP_VERSION = "1.0.1";
